import { BoelsCultureState } from '@boels/models';
import {
  CulturesAction,
  SET_ACTIVE_CULTURE,
  SET_ACTIVE_CURRENCY,
  SET_ACTIVE_LANGUAGE,
} from '../actions/cultures.actions';

export { BoelsCultureState };

export const initialState: BoelsCultureState = {
  activeCulture: '',
  activeLanguage: '',
  activeCurrency: '',
};

export function reducer(
  state = initialState,
  action: CulturesAction,
): BoelsCultureState {
  switch (action.type) {
    case SET_ACTIVE_CULTURE: {
      return {
        ...state,
        activeCulture: action.payload,
      };
    }

    case SET_ACTIVE_CURRENCY: {
      return {
        ...state,
        activeCurrency: action.payload,
      };
    }

    case SET_ACTIVE_LANGUAGE: {
      return {
        ...state,
        activeLanguage: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
